export default "__VITE_ASSET__BmicChtF__"